export default __webpack_public_path__ + "static/media/soft-drink.2312fd0c.svg";